import {USER_EVENTS} from '../../../events/events';
import DOM from '../../../utils/dom';
import Strings from '../../../utils/strings';
import FreePlayVoucherComponentModel from './free_play_voucher_component_model';
import {
    VOUCHER_STATE, VOUCHER_VIEW, EXPIRATION_TYPE, CSS_CLASSES, TRANSLATIONS, FP_VOUCHER_TYPE_NAMES,
    FP_VOUCHER_ICONS_CLASSES, FP_VOUCHER_BACKGROUND_CLASSES, IAlteredFreePlayVoucher
} from './free_play_voucher_consts';
import BaseComponent from '../../../base/base_component';
import {FP_VOUCHER_TYPES} from '../../../../../common/const/free_play_consts';
import _ from '../../../utils/underscore';


const MILLIS_IN_MINUTE = 1000 * 60;
const MILLIS_IN_HOUR = MILLIS_IN_MINUTE * 60;
const MILLIS_IN_DAY = MILLIS_IN_HOUR * 24;

export default class FreePlayVoucherComponentController extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FreePlayVoucherComponentController';

    _selector = 'cgp-fp-voucher-component';

    _model: FreePlayVoucherComponentModel;

    private _expInterval: number;

    init(params) {
        super.init(params);
        this._model = FreePlayVoucherComponentModel.create(params);
        this.subscribe();
    }


    subscribe() {
        // if (this.isDirective()) { //TODO make sure we want subscription only in directive
        //     this.onSystemEvent(SYSTEM_EVENTS.FREE_PLAY_UPDATED, () => {
        //         this._onVouchersUpdated();
        //     });
        // }
    }


    start() {
       if (!this._bakeVoucher()) {
           return this;
       }
       this._changeState(VOUCHER_STATE.INIT, true);
       return this;
    }

    private _languageService() {
        return this.serviceFactory.languageService();
    }

    /**
     * Bake voucher initial state HTML
     * @param voucher
     * @param voucherView
     * @returns {*}
     * @private
     */
    private _bakeVoucher() {
        const voucher = this._model.getVoucher();
        const expiration = this._getVoucherExpiration(voucher);
        let showRemaining = true;
        let options = {precision: 2};
        let voucherValue = voucher.OriginAmount;

        if (_.isNullOrUndefined(voucherValue) || voucherValue === 0) { //TODO add UnitTesting for not Null/Undefined
            voucherValue = voucher.CurrentBalance;
            showRemaining = false;
            options = {precision: 2};
		}

        const voucherHTML = this.bake(VOUCHER_VIEW, {
            amount: this._formatVoucherUnit(voucher.FreePlayTypeId, voucherValue, voucher.SpinBetAmount, options, true),
            balance: showRemaining ? this._getVoucherBalanceText(voucher) : '',
            expiration: expiration ? expiration.text : '',
            voucherName: this._languageService().translation(TRANSLATIONS.VOUCHER_NAME + FP_VOUCHER_TYPE_NAMES[voucher.FreePlayTypeId].toLowerCase()),
            voucherDesc: this._languageService().translation(TRANSLATIONS.VOUCHER_DESC + FP_VOUCHER_TYPE_NAMES[voucher.FreePlayTypeId].toLowerCase()),
            fpIconClass: FP_VOUCHER_ICONS_CLASSES[voucher.FreePlayTypeId],
            fpBgClass: FP_VOUCHER_BACKGROUND_CLASSES[voucher.FreePlayTypeId]
        });
        // TODO add info state

        this.setHTML(voucherHTML);
        if (expiration) {
            this._handleExpirationStyle(expiration.type, voucher);
        }

        this.onDOMEvent(this.getDOMElementByClassName(CSS_CLASSES.VOUCHER_INFO_SELECTOR), USER_EVENTS.ON_CLICK, (event) => {
            event.preventDefault();
            this._model.getContainerRef().sendAnalytics('VoucherInfoOpen');
            this._changeState(VOUCHER_STATE.INFO);
        });

        this.onDOMEvent(this.getDOMElementByClassName(CSS_CLASSES.VOUCHER_CLOSE_SELECTOR), USER_EVENTS.ON_CLICK, (event) => {
            event.preventDefault();
            this._model.getContainerRef().sendAnalytics('VoucherInfoClose');
            this._changeState(VOUCHER_STATE.INIT);
        });

        this.onChildElementEvent(CSS_CLASSES.VOUCHER_CONTAINER_SELECTOR, USER_EVENTS.ON_CLICK, (event) => {
            if (-1 < (event.target as HTMLElement).className.indexOf(CSS_CLASSES.VOUCHER_INFO_SELECTOR) ||
                -1 < (event.target as HTMLElement).className.indexOf(CSS_CLASSES.VOUCHER_CLOSE_SELECTOR)) {
                return;
            }
            this._model.getContainerRef().onVoucherSelected(voucher.ID);
        });

        if (voucher.isNew) { // show new image
            DOM.show(this.getEl().getElementsByClassName(CSS_CLASSES.VOUCHER_NEW_CLASS)[0] as HTMLElement);
        }

        return this;
    }


    /**
     * Assign voucher style according to expiration type
     * @param type
     * @private
     */
    private _handleExpirationStyle(type, voucher) {
        DOM.clearInterval(this._expInterval);
        const expContainer = this.getDOMElementByClassName(CSS_CLASSES.VOUCHER_EXPIRATION_CLASS);
        switch (type) {
            case EXPIRATION_TYPE.TIME:
                DOM.addClass(expContainer, CSS_CLASSES.VOUCHER_EXPIRATION_SOON_CLASS);
                this._expInterval = DOM.setInterval(() => {
                    const expiration = this._getVoucherExpiration(voucher);
                    DOM.html(expiration.text, expContainer);
                    if (expiration.type === EXPIRATION_TYPE.EXPIRED) {
                        this.logger.debug('_hanldeExpirationStyle EXPIRED');
                        this._handleExpirationStyle(expiration.type, voucher);
                    } else {
                    }
                }, 1000);
                break;
            case EXPIRATION_TYPE.DAY:
                DOM.addClass(expContainer, CSS_CLASSES.VOUCHER_EXPIRATION_DAY);
                break;
            case EXPIRATION_TYPE.EXPIRED:
                DOM.addClass(expContainer, CSS_CLASSES.VOUCHER_EXPIRATION_SOON_CLASS);
                this._model.getContainerRef().onVoucherExpired(this._model.getVoucher().ID);
                break;
        }
    }


    /**
     * Handle onVoucherRemoved event from FreePlayComponent.
     */
    // onVoucherRemoved() {
    //     DOM.toggleClass(this.getEl(), 'cgp-fp-voucher-removed-item');
    // }

    /**
     *
     * @param state
     * @param isInit
     * @private
     */
    private _changeState(state: string, isInit = false) {
        if (!isInit) {
            DOM.toggleClass(this.getEl().getElementsByClassName(CSS_CLASSES.VOUCHER_CONTAINER_CLASS)[0], 'hover');
        }

        // DOM.hide(this.getEl().getElementsByClassName(stateContainerSelector)[0]);
       // DOM.show(this.getEl().getElementsByClassName(newState)[0]);
        // switch (state) {
        //     case VOUCHER_STATE.INFO:
        //         break;
        //     case VOUCHER_STATE.INIT:
        //         //hide init
        //         break;
        // }
        this._model.setState(state);
    }


    /**
     * Bake voucher remaining
     * @param voucher
     * @returns {string|*}
     * @private
     */
    private _getVoucherBalanceText(voucher) {
        const stringBalance = new Strings(this._languageService().translation(TRANSLATIONS.VOUCHER_REWARDS_BALANCE));
        return stringBalance.injectIntoCurly({
            balance: '<span class="cgp-theme-property-font-type-secondary">' + (this._formatVoucherUnit(voucher.FreePlayTypeId, voucher.CurrentBalance, voucher.SpinBetAmount, {precision: 2})) + '</span>',
            fp_voucher_remaining_prefix: this._languageService().translation(TRANSLATIONS.VOUCHER_BALANCE_PREFIX)
        });
    }

    /**
     *
     * @param date
     * @returns true if specified date is invalid
     * @private
     */
    private _isDateInvalid(date) {
		return !date || !_.isNumber(date.getTime());
	}

    /**
     * Bake voucher expiration text
     * @param voucher
     * @returns {{text: (string|*), type: (string|*|string|string)}}
     * @private
     */
    private _getVoucherExpiration(voucher: IAlteredFreePlayVoucher): {
        text: string,
        type: string }
    {
        if (this._isDateInvalid(voucher.ExpirationDate)) {
            return undefined;
        }

        const timeToLeft = new Date(voucher.ExpirationDate).getTime() - new Date().getTime();
        // TODO what we need to do in case the vouched is expired
        // if (timeToLeft < 0) {
        //     return;
        // }
        const expiration = this._convertTimeToExpiration(timeToLeft);
        const stringExpiration = new Strings(this._languageService().translation(TRANSLATIONS.VOUCHER_EXPIRATION + expiration.type.toLowerCase()));
        return {
            text: stringExpiration.injectIntoCurly({
                    expiration: '<span class="cgp-theme-property-font-type-secondary">' + expiration.value + '</span>'
                }),
            type: expiration.type
        };
    }

    /**
     * convert expiration voucher time to user friendly format
     * @param time
     * @returns {{}}
     * @private
     */
    private _convertTimeToExpiration(time: number): {
        value: number,
        type: string
    } {
        const expiration: any = {};
        if (0 > time) {
            expiration.value = '00:00:00';
            expiration.type = EXPIRATION_TYPE.EXPIRED;
            return expiration;
        }
        if (time > MILLIS_IN_DAY * 2) {
            let days = time / MILLIS_IN_DAY;
            if (days - parseInt(days.toString()) > 0) {
                days++;
            }
            expiration.value = parseInt(days.toString());
            expiration.type = EXPIRATION_TYPE.DAY;
        } else {
            const hours = parseInt((time / MILLIS_IN_HOUR).toString());
            let restTime = time - hours * MILLIS_IN_HOUR;
            const minutes = parseInt((restTime / MILLIS_IN_MINUTE).toString());
            restTime -= minutes * MILLIS_IN_MINUTE;
            const seconds = parseInt((restTime / 1000).toString());
            expiration.value = (10 > hours ? '0' + hours.toString() : hours) + ':' + (10 > minutes ? '0' + minutes.toString() : minutes) + ':' + (10 > seconds ? '0' + seconds.toString() : seconds);
            expiration.type = EXPIRATION_TYPE.TIME;
        }

        return expiration;
    }


    /**
     * Format voucher rewards according to voucher type
     * @param type
     * @param value
     * @param spinBetAmount
     * @param currencyOptions
     * @param roundValueIfNoDecimals
     * @returns {*}
     * @private
     */
    private _formatVoucherUnit(type: string, value: number, spinBetAmount: number, currencyOptions: any, roundValueIfNoDecimals = false): number|string{
        let result: number|string = value;
        switch (type) {
            case FP_VOUCHER_TYPES.FreePlay:
            case FP_VOUCHER_TYPES.FreeJackpotPlay:
                result = this.serviceFactory.currencyService().formatMoney(value * 1, currencyOptions, roundValueIfNoDecimals);
                break;
            case FP_VOUCHER_TYPES.FreeSpin:
            case FP_VOUCHER_TYPES.FreeJackpotSpin:
                result = value / spinBetAmount;
                break;
        }

        return result;
    }


    shutDown() {
        super.shutDown();
        this.logger.debug('Voucher ' + this._model.getVoucher().ID + ' has been shut down');
    }

}
